import commonService from './common-service';

class ManagementService {
  async getParentFacilities() {
    try {
      const response = await commonService.getFromServer('FMParents', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
  async getGroupCodes(params) {
    try {
      const response = await commonService.getFromServer('FMGroups?parents='+params);
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getInmateMed(params) {
    try {
      const response = await commonService.getFromServer('EOMCounts?'+params,{});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  
  async getChargeCodes(params) {
    try {
      const response = await commonService.getFromServer('FMCharges?parents='+params.parents+'&groupsCodes='+params.groupsCodes, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadEOMFile(params) {
    try {
      const response = await commonService.postToServer('EOMUpload', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadFMMaster(params) {
    try {
      const response = await commonService.postToServer('FMUpload', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
  async eomExcel(params) {
    try {
      const response = await commonService.postToServer('EOMExcel', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getReports(user) {
    try {
      const response = await commonService.getFromServer('Reports', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async deleteReport(reportId) {
    try {
      const response = await commonService.deleteToServer('Reports/'+reportId, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error deleting report');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async reportDownload(params) {
    try {
      await commonService.downloadFromServer('Reports', params);      
    } catch (e) {
      throw new Error(e.message);
    }
  }  
}

export default new ManagementService();
